export default {
  /**
   * 获取地址上的参数
   */
  queryURL() {
    const arr1 = window.location.search.split('?');
    if (!arr1[1]) return {};
    const params = arr1[1].split('&'); // 进行分割成数组
    const obj = {}; // 声明对象
    for (let i = 0; i < params.length; i += 1) {
      const param = params[i].split('='); // 进行分割成数组
      const [, d] = param;
      obj[param[0]] = d; // 为对象赋值
    }
    return obj;
  },
  /**
   * @desc 根据时间,格式 戳返回日期
   * @dome01 DateFormat(1507513800642, 'yyyy/MM/dd hh:mm:ss')  => 2017/10/09 09:50:00
   * @dome02 DateFormat(1507513800642, 'yyyy-MM-dd hh:mm:ss')  => 2017-10-09 09:50:00
   * @dome03 DateFormat(1507513800642, 'yyyy.MM.dd , hh-mm-ss') => 2017.10.09 , 09-50-00
   */
  DateFormat(date, fmt) {
    if (!(date && true)) {
      return date
    }
    date = new Date(parseInt(date))
    var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      'S': date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return fmt
  },

  isArray(val) {
    return Object.prototype.toString.call(val) === '[object Array]' ? val : []
  },
  isObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]' ? val : {}
  },
  isString(val) {
    return Object.prototype.toString.call(val) === '[object String]' ? val : ''
  },
  /**
   * 打开外层遮罩
   */
  openParentMask() {
    window.top.postMessage("openMask()", "*");
  },
  /**
   * 关闭外层遮罩
   */
  closeParentMask() {
    window.top.postMessage("closeMask()", "*");
  },
  /**
   * @desc QQ验证
   * @param { number }
   * @return  { Boolean }
   */
  isQQ(aQQ) {
    var bValidate = RegExp(/^[1-9][0-9]{4,9}$/).test(aQQ);
    return bValidate;
  },
  /**
   * @desc 手机验证
   * @param { number }
   * @return  { Boolean }
   */
  Mobilephone(obj) {
    var result = true;
    var isPhone = /^((\+?86)|(\(\+86\)))?(13[0123456789][0-9]{8}|15[0123456789][0-9]{8}|17[0123456789][0-9]{8}|18[0123456789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/;
    if (isPhone.test(obj)) {

    } else {
      result = false;
    }
    return result;
  },
  /**
   * @desc 固话验证
   * @param { number }
   * @return  { Boolean }
   */
  fixedtelephone(obj) {
    var result = true;
    var isfixed = /^([0-9]{3,4})?[0-9]{7,8}$/;
    if (isfixed.test(obj)) {

    } else {
      result = false;
    }
    return result;
  },
  /**
   * @desc 固话验证&手机验证
   * @param { number }
   * @return  { Boolean }
   */
  phone(obj) {
    var result = true;
    var isPhone = /^((\+?86)|(\(\+86\)))?(13[0123456789][0-9]{8}|15[0123456789][0-9]{8}|17[0123456789][0-9]{8}|18[0123456789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/;
    var isfixed = /^([0-9]{3,4})?[0-9]{7,8}$/;
    if (isPhone.test(obj) || isfixed.test(obj)) {

    } else {
      result = false;
    }
    return result;
  },
  // 点击特色按钮 触发的事件
  ClickApply() {
    parent.window.postMessage("reFreshpage()", "*");
  },
  // 监听页面显示与隐藏 用法如下
  /* documentState(e => {
    if (e === 'visible') {
      this.handleRefresh()
      console.log('刷新最新数据！')
    }
  })
  */
  documentState(callBack) {
    // 各种浏览器兼容
    let state, visibilityChange
    if (typeof document.hidden !== 'undefined') {
      visibilityChange = 'visibilitychange'
      state = 'visibilityState'
    } else if (typeof document.mozHidden !== 'undefined') {
      visibilityChange = 'mozvisibilitychange'
      state = 'mozVisibilityState'
    } else if (typeof document.msHidden !== 'undefined') {
      visibilityChange = 'msvisibilitychange'
      state = 'msVisibilityState'
    } else if (typeof document.webkitHidden !== 'undefined') {
      visibilityChange = 'webkitvisibilitychange'
      state = 'webkitVisibilityState'
    }

    // 添加监听器，在title里显示状态变化
    document.addEventListener(
      visibilityChange,
      function () {
        callBack(document[state])
      },
      false
    )
  },
  //监听网络发生变化   navigator.onLine（true/false） 检测有没有断网
  netWorkChange() {
    var connection = navigator.connection;
    var type = connection.effectiveType;

    function updateConnectionStatus() {
      console.log("网络状况从 " + type + " 切换至" + connection.effectiveType);
      type = connection.effectiveType;
    }

    connection.addEventListener('change', updateConnectionStatus);
  }
}
